!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.Popper = t()
}(this, function() {
    "use strict";
    var n = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
        o = function() {
            for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
                if (n && 0 <= navigator.userAgent.indexOf(e[t]))
                    return 1;
            return 0
        }();
    var i = n && window.Promise ? function(e) {
        var t = !1;
        return function() {
            t || (t = !0, window.Promise.resolve().then(function() {
                t = !1,
                e()
            }))
        }
    } : function(e) {
        var t = !1;
        return function() {
            t || (t = !0, setTimeout(function() {
                t = !1,
                e()
            }, o))
        }
    };
    function a(e) {
        return e && "[object Function]" === {}.toString.call(e)
    }
    function y(e, t) {
        if (1 !== e.nodeType)
            return [];
        var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
        return t ? n[t] : n
    }
    function h(e) {
        return "HTML" === e.nodeName ? e : e.parentNode || e.host
    }
    function m(e) {
        if (!e)
            return document.body;
        switch (e.nodeName) {
        case "HTML":
        case "BODY":
            return e.ownerDocument.body;
        case "#document":
            return e.body
        }
        var t = y(e),
            n = t.overflow,
            o = t.overflowX,
            r = t.overflowY;
        return /(auto|scroll|overlay)/.test(n + r + o) ? e : m(h(e))
    }
    function v(e) {
        return e && e.referenceNode ? e.referenceNode : e
    }
    var t = n && !(!window.MSInputMethodContext || !document.documentMode),
        r = n && /MSIE 10/.test(navigator.userAgent);
    function g(e) {
        return 11 === e ? t : 10 !== e && t || r
    }
    function w(e) {
        if (!e)
            return document.documentElement;
        for (var t = g(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;)
            n = (e = e.nextElementSibling).offsetParent;
        var o = n && n.nodeName;
        return o && "BODY" !== o && "HTML" !== o ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === y(n, "position") ? w(n) : n : e ? e.ownerDocument.documentElement : document.documentElement
    }
    function l(e) {
        return null !== e.parentNode ? l(e.parentNode) : e
    }
    function b(e, t) {
        if (!(e && e.nodeType && t && t.nodeType))
            return document.documentElement;
        var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
            o = n ? e : t,
            r = n ? t : e,
            i = document.createRange();
        i.setStart(o, 0),
        i.setEnd(r, 0);
        var a,
            s,
            f = i.commonAncestorContainer;
        if (e !== f && t !== f || o.contains(r))
            return "BODY" === (s = (a = f).nodeName) || "HTML" !== s && w(a.firstElementChild) !== a ? w(f) : f;
        var p = l(e);
        return p.host ? b(p.host, t) : b(e, l(t).host)
    }
    function x(e, t) {
        var n = "top" === (1 < arguments.length && void 0 !== t ? t : "top") ? "scrollTop" : "scrollLeft",
            o = e.nodeName;
        if ("BODY" !== o && "HTML" !== o)
            return e[n];
        var r = e.ownerDocument.documentElement;
        return (e.ownerDocument.scrollingElement || r)[n]
    }
    function d(e, t) {
        var n = "x" === t ? "Left" : "Top",
            o = "Left" == n ? "Right" : "Bottom";
        return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + o + "Width"])
    }
    function s(e, t, n, o) {
        return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], g(10) ? parseInt(n["offset" + e]) + parseInt(o["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(o["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0)
    }
    function E(e) {
        var t = e.body,
            n = e.documentElement,
            o = g(10) && getComputedStyle(n);
        return {
            height: s("Height", t, n, o),
            width: s("Width", t, n, o)
        }
    }
    var e = function(e, t, n) {
        return t && f(e.prototype, t), n && f(e, n), e
    };
    function f(e, t) {
        for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1,
            o.configurable = !0,
            "value" in o && (o.writable = !0),
            Object.defineProperty(e, o.key, o)
        }
    }
    function O(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }
    var L = Object.assign || function(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o])
        }
        return e
    };
    function T(e) {
        return L({}, e, {
            right: e.left + e.width,
            bottom: e.top + e.height
        })
    }
    function D(e) {
        var t = {};
        try {
            if (g(10)) {
                t = e.getBoundingClientRect();
                var n = x(e, "top"),
                    o = x(e, "left");
                t.top += n,
                t.left += o,
                t.bottom += n,
                t.right += o
            } else
                t = e.getBoundingClientRect()
        } catch (e) {}
        var r = {
                left: t.left,
                top: t.top,
                width: t.right - t.left,
                height: t.bottom - t.top
            },
            i = "HTML" === e.nodeName ? E(e.ownerDocument) : {},
            a = i.width || e.clientWidth || r.width,
            s = i.height || e.clientHeight || r.height,
            f = e.offsetWidth - a,
            p = e.offsetHeight - s;
        if (f || p) {
            var l = y(e);
            f -= d(l, "x"),
            p -= d(l, "y"),
            r.width -= f,
            r.height -= p
        }
        return T(r)
    }
    function M(e, t, n) {
        var o = 2 < arguments.length && void 0 !== n && n,
            r = g(10),
            i = "HTML" === t.nodeName,
            a = D(e),
            s = D(t),
            f = m(e),
            p = y(t),
            l = parseFloat(p.borderTopWidth),
            d = parseFloat(p.borderLeftWidth);
        o && i && (s.top = Math.max(s.top, 0), s.left = Math.max(s.left, 0));
        var u = T({
            top: a.top - s.top - l,
            left: a.left - s.left - d,
            width: a.width,
            height: a.height
        });
        if (u.marginTop = 0, u.marginLeft = 0, !r && i) {
            var c = parseFloat(p.marginTop),
                h = parseFloat(p.marginLeft);
            u.top -= l - c,
            u.bottom -= l - c,
            u.left -= d - h,
            u.right -= d - h,
            u.marginTop = c,
            u.marginLeft = h
        }
        return (r && !o ? t.contains(f) : t === f && "BODY" !== f.nodeName) && (u = function(e, t, n) {
            var o = 2 < arguments.length && void 0 !== n && n,
                r = x(t, "top"),
                i = x(t, "left"),
                a = o ? -1 : 1;
            return e.top += r * a, e.bottom += r * a, e.left += i * a, e.right += i * a, e
        }(u, t)), u
    }
    function N(e) {
        if (!e || !e.parentElement || g())
            return document.documentElement;
        for (var t = e.parentElement; t && "none" === y(t, "transform");)
            t = t.parentElement;
        return t || document.documentElement
    }
    function c(e, t, n, o, r) {
        var i = 4 < arguments.length && void 0 !== r && r,
            a = {
                top: 0,
                left: 0
            },
            s = i ? N(e) : b(e, v(t));
        if ("viewport" === o)
            a = function(e, t) {
                var n = 1 < arguments.length && void 0 !== t && t,
                    o = e.ownerDocument.documentElement,
                    r = M(e, o),
                    i = Math.max(o.clientWidth, window.innerWidth || 0),
                    a = Math.max(o.clientHeight, window.innerHeight || 0),
                    s = n ? 0 : x(o),
                    f = n ? 0 : x(o, "left");
                return T({
                    top: s - r.top + r.marginTop,
                    left: f - r.left + r.marginLeft,
                    width: i,
                    height: a
                })
            }(s, i);
        else {
            var f = void 0;
            "scrollParent" === o ? "BODY" === (f = m(h(t))).nodeName && (f = e.ownerDocument.documentElement) : f = "window" === o ? e.ownerDocument.documentElement : o;
            var p = M(f, s, i);
            if ("HTML" !== f.nodeName || function e(t) {
                var n = t.nodeName;
                if ("BODY" === n || "HTML" === n)
                    return !1;
                if ("fixed" === y(t, "position"))
                    return !0;
                var o = h(t);
                return !!o && e(o)
            }(s))
                a = p;
            else {
                var l = E(e.ownerDocument),
                    d = l.height,
                    u = l.width;
                a.top += p.top - p.marginTop,
                a.bottom = d + p.top,
                a.left += p.left - p.marginLeft,
                a.right = u + p.left
            }
        }
        var c = "number" == typeof (n = n || 0);
        return a.left += c ? n : n.left || 0, a.top += c ? n : n.top || 0, a.right -= c ? n : n.right || 0, a.bottom -= c ? n : n.bottom || 0, a
    }
    function p(e, t, o, n, r, i) {
        var a = 5 < arguments.length && void 0 !== i ? i : 0;
        if (-1 === e.indexOf("auto"))
            return e;
        var s = c(o, n, a, r),
            f = {
                top: {
                    width: s.width,
                    height: t.top - s.top
                },
                right: {
                    width: s.right - t.right,
                    height: s.height
                },
                bottom: {
                    width: s.width,
                    height: s.bottom - t.bottom
                },
                left: {
                    width: t.left - s.left,
                    height: s.height
                }
            },
            p = Object.keys(f).map(function(e) {
                return L({
                    key: e
                }, f[e], {
                    area: (t = f[e]).width * t.height
                });
                var t
            }).sort(function(e, t) {
                return t.area - e.area
            }),
            l = p.filter(function(e) {
                var t = e.width,
                    n = e.height;
                return t >= o.clientWidth && n >= o.clientHeight
            }),
            d = 0 < l.length ? l[0].key : p[0].key,
            u = e.split("-")[1];
        return d + (u ? "-" + u : "")
    }
    function u(e, t, n, o) {
        var r = 3 < arguments.length && void 0 !== o ? o : null;
        return M(n, r ? N(t) : b(t, v(n)), r)
    }
    function F(e) {
        var t = e.ownerDocument.defaultView.getComputedStyle(e),
            n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
            o = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
        return {
            width: e.offsetWidth + o,
            height: e.offsetHeight + n
        }
    }
    function k(e) {
        var t = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return e.replace(/left|right|bottom|top/g, function(e) {
            return t[e]
        })
    }
    function H(e, t, n) {
        n = n.split("-")[0];
        var o = F(e),
            r = {
                width: o.width,
                height: o.height
            },
            i = -1 !== ["right", "left"].indexOf(n),
            a = i ? "top" : "left",
            s = i ? "left" : "top",
            f = i ? "height" : "width",
            p = i ? "width" : "height";
        return r[a] = t[a] + t[f] / 2 - o[f] / 2, r[s] = n === s ? t[s] - o[p] : t[k(s)], r
    }
    function C(e, t) {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0]
    }
    function B(e, n, t) {
        return (void 0 === t ? e : e.slice(0, function(e, t, n) {
            if (Array.prototype.findIndex)
                return e.findIndex(function(e) {
                    return e[t] === n
                });
            var o = C(e, function(e) {
                return e[t] === n
            });
            return e.indexOf(o)
        }(e, "name", t))).forEach(function(e) {
            e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var t = e.function || e.fn;
            e.enabled && a(t) && (n.offsets.popper = T(n.offsets.popper), n.offsets.reference = T(n.offsets.reference), n = t(n, e))
        }), n
    }
    function A(e, n) {
        return e.some(function(e) {
            var t = e.name;
            return e.enabled && t === n
        })
    }
    function P(e) {
        for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), o = 0; o < t.length; o++) {
            var r = t[o],
                i = r ? "" + r + n : e;
            if (void 0 !== document.body.style[i])
                return i
        }
        return null
    }
    function S(e) {
        var t = e.ownerDocument;
        return t ? t.defaultView : window
    }
    function W(e, t, n, o) {
        n.updateBound = o,
        S(e).addEventListener("resize", n.updateBound, {
            passive: !0
        });
        var r = m(e);
        return function e(t, n, o, r) {
            var i = "BODY" === t.nodeName,
                a = i ? t.ownerDocument.defaultView : t;
            a.addEventListener(n, o, {
                passive: !0
            }),
            i || e(m(a.parentNode), n, o, r),
            r.push(a)
        }(r, "scroll", n.updateBound, n.scrollParents), n.scrollElement = r, n.eventsEnabled = !0, n
    }
    function j() {
        var e,
            t;
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, S(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function(e) {
            e.removeEventListener("scroll", t.updateBound)
        }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t))
    }
    function I(e) {
        return "" !== e && !isNaN(parseFloat(e)) && isFinite(e)
    }
    function R(n, o) {
        Object.keys(o).forEach(function(e) {
            var t = "";
            -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(e) && I(o[e]) && (t = "px"),
            n.style[e] = o[e] + t
        })
    }
    function U(e, t) {
        function n(e) {
            return e
        }
        var o = e.offsets,
            r = o.popper,
            i = o.reference,
            a = Math.round,
            s = Math.floor,
            f = a(i.width),
            p = a(r.width),
            l = -1 !== ["left", "right"].indexOf(e.placement),
            d = -1 !== e.placement.indexOf("-"),
            u = t ? l || d || f % 2 == p % 2 ? a : s : n,
            c = t ? a : n;
        return {
            left: u(f % 2 == 1 && p % 2 == 1 && !d && t ? r.left - 1 : r.left),
            top: c(r.top),
            bottom: c(r.bottom),
            right: u(r.right)
        }
    }
    var Y = n && /Firefox/i.test(navigator.userAgent);
    function V(e, t, n) {
        var o = C(e, function(e) {
                return e.name === t
            }),
            r = !!o && e.some(function(e) {
                return e.name === n && e.enabled && e.order < o.order
            });
        if (!r) {
            var i = "`" + t + "`",
                a = "`" + n + "`";
            console.warn(a + " modifier is required by " + i + " modifier in order to work, be sure to include it before " + i + "!")
        }
        return r
    }
    var q = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
        z = q.slice(3);
    function G(e, t) {
        var n = 1 < arguments.length && void 0 !== t && t,
            o = z.indexOf(e),
            r = z.slice(o + 1).concat(z.slice(0, o));
        return n ? r.reverse() : r
    }
    var _ = "flip",
        X = "clockwise",
        J = "counterclockwise";
    function K(e, r, i, t) {
        var a = [0, 0],
            s = -1 !== ["right", "left"].indexOf(t),
            n = e.split(/(\+|\-)/).map(function(e) {
                return e.trim()
            }),
            o = n.indexOf(C(n, function(e) {
                return -1 !== e.search(/,|\s/)
            }));
        n[o] && -1 === n[o].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var f = /\s*,\s*|\s+/,
            p = -1 !== o ? [n.slice(0, o).concat([n[o].split(f)[0]]), [n[o].split(f)[1]].concat(n.slice(o + 1))] : [n];
        return (p = p.map(function(e, t) {
            var n = (1 === t ? !s : s) ? "height" : "width",
                o = !1;
            return e.reduce(function(e, t) {
                return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, o = !0, e) : o ? (e[e.length - 1] += t, o = !1, e) : e.concat(t)
            }, []).map(function(e) {
                return function(e, t, n, o) {
                    var r = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                        i = +r[1],
                        a = r[2];
                    if (!i)
                        return e;
                    if (0 !== a.indexOf("%"))
                        return "vh" !== a && "vw" !== a ? i : ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * i;
                    var s = void 0;
                    switch (a) {
                    case "%p":
                        s = n;
                        break;
                    case "%":
                    case "%r":
                    default:
                        s = o
                    }
                    return T(s)[t] / 100 * i
                }(e, n, r, i)
            })
        })).forEach(function(n, o) {
            n.forEach(function(e, t) {
                I(e) && (a[o] += e * ("-" === n[t - 1] ? -1 : 1))
            })
        }), a
    }
    var Q = {
            placement: "bottom",
            positionFixed: !1,
            eventsEnabled: !0,
            removeOnDestroy: !1,
            onCreate: function() {},
            onUpdate: function() {},
            modifiers: {
                shift: {
                    order: 100,
                    enabled: !0,
                    fn: function(e) {
                        var t = e.placement,
                            n = t.split("-")[0],
                            o = t.split("-")[1];
                        if (o) {
                            var r = e.offsets,
                                i = r.reference,
                                a = r.popper,
                                s = -1 !== ["bottom", "top"].indexOf(n),
                                f = s ? "left" : "top",
                                p = s ? "width" : "height",
                                l = {
                                    start: O({}, f, i[f]),
                                    end: O({}, f, i[f] + i[p] - a[p])
                                };
                            e.offsets.popper = L({}, a, l[o])
                        }
                        return e
                    }
                },
                offset: {
                    order: 200,
                    enabled: !0,
                    fn: function(e, t) {
                        var n = t.offset,
                            o = e.placement,
                            r = e.offsets,
                            i = r.popper,
                            a = r.reference,
                            s = o.split("-")[0],
                            f = void 0;
                        return f = I(+n) ? [+n, 0] : K(n, i, a, s), "left" === s ? (i.top += f[0], i.left -= f[1]) : "right" === s ? (i.top += f[0], i.left += f[1]) : "top" === s ? (i.left += f[0], i.top -= f[1]) : "bottom" === s && (i.left += f[0], i.top += f[1]), e.popper = i, e
                    },
                    offset: 0
                },
                preventOverflow: {
                    order: 300,
                    enabled: !0,
                    fn: function(e, o) {
                        var t = o.boundariesElement || w(e.instance.popper);
                        e.instance.reference === t && (t = w(t));
                        var n = P("transform"),
                            r = e.instance.popper.style,
                            i = r.top,
                            a = r.left,
                            s = r[n];
                        r.top = "",
                        r.left = "",
                        r[n] = "";
                        var f = c(e.instance.popper, e.instance.reference, o.padding, t, e.positionFixed);
                        r.top = i,
                        r.left = a,
                        r[n] = s,
                        o.boundaries = f;
                        var p = o.priority,
                            l = e.offsets.popper,
                            d = {
                                primary: function(e) {
                                    var t = l[e];
                                    return l[e] < f[e] && !o.escapeWithReference && (t = Math.max(l[e], f[e])), O({}, e, t)
                                },
                                secondary: function(e) {
                                    var t = "right" === e ? "left" : "top",
                                        n = l[t];
                                    return l[e] > f[e] && !o.escapeWithReference && (n = Math.min(l[t], f[e] - ("right" === e ? l.width : l.height))), O({}, t, n)
                                }
                            };
                        return p.forEach(function(e) {
                            var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                            l = L({}, l, d[t](e))
                        }), e.offsets.popper = l, e
                    },
                    priority: ["left", "right", "top", "bottom"],
                    padding: 5,
                    boundariesElement: "scrollParent"
                },
                keepTogether: {
                    order: 400,
                    enabled: !0,
                    fn: function(e) {
                        var t = e.offsets,
                            n = t.popper,
                            o = t.reference,
                            r = e.placement.split("-")[0],
                            i = Math.floor,
                            a = -1 !== ["top", "bottom"].indexOf(r),
                            s = a ? "right" : "bottom",
                            f = a ? "left" : "top",
                            p = a ? "width" : "height";
                        return n[s] < i(o[f]) && (e.offsets.popper[f] = i(o[f]) - n[p]), n[f] > i(o[s]) && (e.offsets.popper[f] = i(o[s])), e
                    }
                },
                arrow: {
                    order: 500,
                    enabled: !0,
                    fn: function(e, t) {
                        var n;
                        if (!V(e.instance.modifiers, "arrow", "keepTogether"))
                            return e;
                        var o = t.element;
                        if ("string" == typeof o) {
                            if (!(o = e.instance.popper.querySelector(o)))
                                return e
                        } else if (!e.instance.popper.contains(o))
                            return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
                        var r = e.placement.split("-")[0],
                            i = e.offsets,
                            a = i.popper,
                            s = i.reference,
                            f = -1 !== ["left", "right"].indexOf(r),
                            p = f ? "height" : "width",
                            l = f ? "Top" : "Left",
                            d = l.toLowerCase(),
                            u = f ? "left" : "top",
                            c = f ? "bottom" : "right",
                            h = F(o)[p];
                        s[c] - h < a[d] && (e.offsets.popper[d] -= a[d] - (s[c] - h)),
                        s[d] + h > a[c] && (e.offsets.popper[d] += s[d] + h - a[c]),
                        e.offsets.popper = T(e.offsets.popper);
                        var m = s[d] + s[p] / 2 - h / 2,
                            v = y(e.instance.popper),
                            g = parseFloat(v["margin" + l]),
                            b = parseFloat(v["border" + l + "Width"]),
                            w = m - e.offsets.popper[d] - g - b;
                        return w = Math.max(Math.min(a[p] - h, w), 0), e.arrowElement = o, e.offsets.arrow = (O(n = {}, d, Math.round(w)), O(n, u, ""), n), e
                    },
                    element: "[x-arrow]"
                },
                flip: {
                    order: 600,
                    enabled: !0,
                    fn: function(v, g) {
                        if (A(v.instance.modifiers, "inner"))
                            return v;
                        if (v.flipped && v.placement === v.originalPlacement)
                            return v;
                        var b = c(v.instance.popper, v.instance.reference, g.padding, g.boundariesElement, v.positionFixed),
                            w = v.placement.split("-")[0],
                            y = k(w),
                            x = v.placement.split("-")[1] || "",
                            E = [];
                        switch (g.behavior) {
                        case _:
                            E = [w, y];
                            break;
                        case X:
                            E = G(w);
                            break;
                        case J:
                            E = G(w, !0);
                            break;
                        default:
                            E = g.behavior
                        }
                        return E.forEach(function(e, t) {
                            if (w !== e || E.length === t + 1)
                                return v;
                            w = v.placement.split("-")[0],
                            y = k(w);
                            var n,
                                o = v.offsets.popper,
                                r = v.offsets.reference,
                                i = Math.floor,
                                a = "left" === w && i(o.right) > i(r.left) || "right" === w && i(o.left) < i(r.right) || "top" === w && i(o.bottom) > i(r.top) || "bottom" === w && i(o.top) < i(r.bottom),
                                s = i(o.left) < i(b.left),
                                f = i(o.right) > i(b.right),
                                p = i(o.top) < i(b.top),
                                l = i(o.bottom) > i(b.bottom),
                                d = "left" === w && s || "right" === w && f || "top" === w && p || "bottom" === w && l,
                                u = -1 !== ["top", "bottom"].indexOf(w),
                                c = !!g.flipVariations && (u && "start" === x && s || u && "end" === x && f || !u && "start" === x && p || !u && "end" === x && l),
                                h = !!g.flipVariationsByContent && (u && "start" === x && f || u && "end" === x && s || !u && "start" === x && l || !u && "end" === x && p),
                                m = c || h;
                            (a || d || m) && (v.flipped = !0, (a || d) && (w = E[t + 1]), m && (x = "end" === (n = x) ? "start" : "start" === n ? "end" : n), v.placement = w + (x ? "-" + x : ""), v.offsets.popper = L({}, v.offsets.popper, H(v.instance.popper, v.offsets.reference, v.placement)), v = B(v.instance.modifiers, v, "flip"))
                        }), v
                    },
                    behavior: "flip",
                    padding: 5,
                    boundariesElement: "viewport",
                    flipVariations: !1,
                    flipVariationsByContent: !1
                },
                inner: {
                    order: 700,
                    enabled: !1,
                    fn: function(e) {
                        var t = e.placement,
                            n = t.split("-")[0],
                            o = e.offsets,
                            r = o.popper,
                            i = o.reference,
                            a = -1 !== ["left", "right"].indexOf(n),
                            s = -1 === ["top", "left"].indexOf(n);
                        return r[a ? "left" : "top"] = i[n] - (s ? r[a ? "width" : "height"] : 0), e.placement = k(t), e.offsets.popper = T(r), e
                    }
                },
                hide: {
                    order: 800,
                    enabled: !0,
                    fn: function(e) {
                        if (!V(e.instance.modifiers, "hide", "preventOverflow"))
                            return e;
                        var t = e.offsets.reference,
                            n = C(e.instance.modifiers, function(e) {
                                return "preventOverflow" === e.name
                            }).boundaries;
                        if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                            if (!0 === e.hide)
                                return e;
                            e.hide = !0,
                            e.attributes["x-out-of-boundaries"] = ""
                        } else {
                            if (!1 === e.hide)
                                return e;
                            e.hide = !1,
                            e.attributes["x-out-of-boundaries"] = !1
                        }
                        return e
                    }
                },
                computeStyle: {
                    order: 850,
                    enabled: !0,
                    fn: function(e, t) {
                        var n = t.x,
                            o = t.y,
                            r = e.offsets.popper,
                            i = C(e.instance.modifiers, function(e) {
                                return "applyStyle" === e.name
                            }).gpuAcceleration;
                        void 0 !== i && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                        var a = void 0 !== i ? i : t.gpuAcceleration,
                            s = w(e.instance.popper),
                            f = D(s),
                            p = {
                                position: r.position
                            },
                            l = U(e, window.devicePixelRatio < 2 || !Y),
                            d = "bottom" === n ? "top" : "bottom",
                            u = "right" === o ? "left" : "right",
                            c = P("transform"),
                            h = void 0,
                            m = void 0;
                        if (m = "bottom" == d ? "HTML" === s.nodeName ? -s.clientHeight + l.bottom : -f.height + l.bottom : l.top, h = "right" == u ? "HTML" === s.nodeName ? -s.clientWidth + l.right : -f.width + l.right : l.left, a && c)
                            p[c] = "translate3d(" + h + "px, " + m + "px, 0)",
                            p[d] = 0,
                            p[u] = 0,
                            p.willChange = "transform";
                        else {
                            var v = "bottom" == d ? -1 : 1,
                                g = "right" == u ? -1 : 1;
                            p[d] = m * v,
                            p[u] = h * g,
                            p.willChange = d + ", " + u
                        }
                        var b = {
                            "x-placement": e.placement
                        };
                        return e.attributes = L({}, b, e.attributes), e.styles = L({}, p, e.styles), e.arrowStyles = L({}, e.offsets.arrow, e.arrowStyles), e
                    },
                    gpuAcceleration: !0,
                    x: "bottom",
                    y: "right"
                },
                applyStyle: {
                    order: 900,
                    enabled: !0,
                    fn: function(e) {
                        var t,
                            n;
                        return R(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach(function(e) {
                            !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e)
                        }), e.arrowElement && Object.keys(e.arrowStyles).length && R(e.arrowElement, e.arrowStyles), e
                    },
                    onLoad: function(e, t, n, o, r) {
                        var i = u(r, t, e, n.positionFixed),
                            a = p(n.placement, i, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                        return t.setAttribute("x-placement", a), R(t, {
                            position: n.positionFixed ? "fixed" : "absolute"
                        }), n
                    },
                    gpuAcceleration: void 0
                }
            }
        },
        Z = (e($, [{
            key: "update",
            value: function() {
                return function() {
                    if (!this.state.isDestroyed) {
                        var e = {
                            instance: this,
                            styles: {},
                            arrowStyles: {},
                            attributes: {},
                            flipped: !1,
                            offsets: {}
                        };
                        e.offsets.reference = u(this.state, this.popper, this.reference, this.options.positionFixed),
                        e.placement = p(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding),
                        e.originalPlacement = e.placement,
                        e.positionFixed = this.options.positionFixed,
                        e.offsets.popper = H(this.popper, e.offsets.reference, e.placement),
                        e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute",
                        e = B(this.modifiers, e),
                        this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e))
                    }
                }.call(this)
            }
        }, {
            key: "destroy",
            value: function() {
                return function() {
                    return this.state.isDestroyed = !0, A(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[P("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
                }.call(this)
            }
        }, {
            key: "enableEventListeners",
            value: function() {
                return function() {
                    this.state.eventsEnabled || (this.state = W(this.reference, this.options, this.state, this.scheduleUpdate))
                }.call(this)
            }
        }, {
            key: "disableEventListeners",
            value: function() {
                return j.call(this)
            }
        }]), $);
    function $(e, t) {
        var n = this,
            o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
        !function(e, t) {
            if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function")
        }(this, $),
        this.scheduleUpdate = function() {
            return requestAnimationFrame(n.update)
        },
        this.update = i(this.update.bind(this)),
        this.options = L({}, $.Defaults, o),
        this.state = {
            isDestroyed: !1,
            isCreated: !1,
            scrollParents: []
        },
        this.reference = e && e.jquery ? e[0] : e,
        this.popper = t && t.jquery ? t[0] : t,
        this.options.modifiers = {},
        Object.keys(L({}, $.Defaults.modifiers, o.modifiers)).forEach(function(e) {
            n.options.modifiers[e] = L({}, $.Defaults.modifiers[e] || {}, o.modifiers ? o.modifiers[e] : {})
        }),
        this.modifiers = Object.keys(this.options.modifiers).map(function(e) {
            return L({
                name: e
            }, n.options.modifiers[e])
        }).sort(function(e, t) {
            return e.order - t.order
        }),
        this.modifiers.forEach(function(e) {
            e.enabled && a(e.onLoad) && e.onLoad(n.reference, n.popper, n.options, e, n.state)
        }),
        this.update();
        var r = this.options.eventsEnabled;
        r && this.enableEventListeners(),
        this.state.eventsEnabled = r
    }
    return Z.Utils = ("undefined" != typeof window ? window : global).PopperUtils, Z.placements = q, Z.Defaults = Q, Z
});



!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("jquery")) : "function" == typeof define && define.amd ? define(["jquery"], e) : (t = t || self).Util = e(t.jQuery)
}(this, function(i) {
    "use strict";
    i = i && i.hasOwnProperty("default") ? i.default : i;
    var e = "transitionend";
    function t(t) {
        var e = this,
            n = !1;
        return i(this).one(s.TRANSITION_END, function() {
            n = !0
        }), setTimeout(function() {
            n || s.triggerTransitionEnd(e)
        }, t), this
    }
    var s = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function(t) {
            for (; t += ~~(1e6 * Math.random()), document.getElementById(t);)
                ;
            return t
        },
        getSelectorFromElement: function(t) {
            var e = t.getAttribute("data-target");
            if (!e || "#" === e) {
                var n = t.getAttribute("href");
                e = n && "#" !== n ? n.trim() : ""
            }
            try {
                return document.querySelector(e) ? e : null
            } catch (t) {
                return null
            }
        },
        getTransitionDurationFromElement: function(t) {
            if (!t)
                return 0;
            var e = i(t).css("transition-duration"),
                n = i(t).css("transition-delay"),
                r = parseFloat(e),
                o = parseFloat(n);
            return r || o ? (e = e.split(",")[0], n = n.split(",")[0], 1e3 * (parseFloat(e) + parseFloat(n))) : 0
        },
        reflow: function(t) {
            return t.offsetHeight
        },
        triggerTransitionEnd: function(t) {
            i(t).trigger(e)
        },
        supportsTransitionEnd: function() {
            return Boolean(e)
        },
        isElement: function(t) {
            return (t[0] || t).nodeType
        },
        typeCheckConfig: function(t, e, n) {
            for (var r in n)
                if (Object.prototype.hasOwnProperty.call(n, r)) {
                    var o = n[r],
                        i = e[r],
                        a = i && s.isElement(i) ? "element" : (u = i, {}.toString.call(u).match(/\s([a-z]+)/i)[1].toLowerCase());
                    if (!new RegExp(o).test(a))
                        throw new Error(t.toUpperCase() + ': Option "' + r + '" provided type "' + a + '" but expected type "' + o + '".')
                }
            var u
        },
        findShadowRoot: function(t) {
            if (!document.documentElement.attachShadow)
                return null;
            if ("function" != typeof t.getRootNode)
                return t instanceof ShadowRoot ? t : t.parentNode ? s.findShadowRoot(t.parentNode) : null;
            var e = t.getRootNode();
            return e instanceof ShadowRoot ? e : null
        },
        jQueryDetection: function() {
            if (void 0 === i)
                throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var t = i.fn.jquery.split(" ")[0].split(".");
            if (t[0] < 2 && t[1] < 9 || 1 === t[0] && 9 === t[1] && t[2] < 1 || 4 <= t[0])
                throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")
        }
    };
    return s.jQueryDetection(), i.fn.emulateTransitionEnd = t, i.event.special[s.TRANSITION_END] = {
        bindType: e,
        delegateType: e,
        handle: function(t) {
            if (i(t.target).is(this))
                return t.handleObj.handler.apply(this, arguments)
        }
    }, s
});


!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("jquery"), require("./util.js")) : "function" == typeof define && define.amd ? define(["jquery", "./util.js"], t) : (e = e || self).Alert = t(e.jQuery, e.Util)
}(this, function(i, u) {
    "use strict";
    function s(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    i = i && i.hasOwnProperty("default") ? i.default : i,
    u = u && u.hasOwnProperty("default") ? u.default : u;
    var e = "alert",
        l = "bs.alert",
        t = "." + l,
        n = i.fn[e],
        a = {
            CLOSE: "close" + t,
            CLOSED: "closed" + t,
            CLICK_DATA_API: "click" + t + ".data-api"
        },
        f = "alert",
        c = "fade",
        d = "show",
        r = function() {
            function r(e) {
                this._element = e
            }
            var e,
                t,
                n,
                o = r.prototype;
            return o.close = function(e) {
                var t = this._element;
                e && (t = this._getRootElement(e)),
                this._triggerCloseEvent(t).isDefaultPrevented() || this._removeElement(t)
            }, o.dispose = function() {
                i.removeData(this._element, l),
                this._element = null
            }, o._getRootElement = function(e) {
                var t = u.getSelectorFromElement(e),
                    n = !1;
                return t && (n = document.querySelector(t)), n = n || i(e).closest("." + f)[0]
            }, o._triggerCloseEvent = function(e) {
                var t = i.Event(a.CLOSE);
                return i(e).trigger(t), t
            }, o._removeElement = function(t) {
                var n = this;
                if (i(t).removeClass(d), i(t).hasClass(c)) {
                    var e = u.getTransitionDurationFromElement(t);
                    i(t).one(u.TRANSITION_END, function(e) {
                        return n._destroyElement(t, e)
                    }).emulateTransitionEnd(e)
                } else
                    this._destroyElement(t)
            }, o._destroyElement = function(e) {
                i(e).detach().trigger(a.CLOSED).remove()
            }, r._jQueryInterface = function(n) {
                return this.each(function() {
                    var e = i(this),
                        t = e.data(l);
                    t || (t = new r(this), e.data(l, t)),
                    "close" === n && t[n](this)
                })
            }, r._handleDismiss = function(t) {
                return function(e) {
                    e && e.preventDefault(),
                    t.close(this)
                }
            }, e = r, n = [{
                key: "VERSION",
                get: function() {
                    return "4.4.1"
                }
            }], (t = null) && s(e.prototype, t), n && s(e, n), r
        }();
    return i(document).on(a.CLICK_DATA_API, '[data-dismiss="alert"]', r._handleDismiss(new r)), i.fn[e] = r._jQueryInterface, i.fn[e].Constructor = r, i.fn[e].noConflict = function() {
        return i.fn[e] = n, r._jQueryInterface
    }, r
});


!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("jquery")) : "function" == typeof define && define.amd ? define(["jquery"], t) : (e = e || self).Button = t(e.jQuery)
}(this, function(i) {
    "use strict";
    function r(e, t) {
        for (var n = 0; n < t.length; n++) {
            var s = t[n];
            s.enumerable = s.enumerable || !1,
            s.configurable = !0,
            "value" in s && (s.writable = !0),
            Object.defineProperty(e, s.key, s)
        }
    }
    i = i && i.hasOwnProperty("default") ? i.default : i;
    var e = "button",
        l = "bs.button",
        t = "." + l,
        n = ".data-api",
        s = i.fn[e],
        o = "active",
        a = "btn",
        c = "focus",
        u = '[data-toggle^="button"]',
        f = '[data-toggle="buttons"]',
        d = '[data-toggle="button"]',
        h = '[data-toggle="buttons"] .btn',
        _ = 'input:not([type="hidden"])',
        b = ".active",
        g = ".btn",
        A = {
            CLICK_DATA_API: "click" + t + n,
            FOCUS_BLUR_DATA_API: "focus" + t + n + " blur" + t + n,
            LOAD_DATA_API: "load" + t + n
        },
        m = function() {
            function n(e) {
                this._element = e
            }
            var e,
                t,
                s,
                a = n.prototype;
            return a.toggle = function() {
                var e = !0,
                    t = !0,
                    n = i(this._element).closest(f)[0];
                if (n) {
                    var s = this._element.querySelector(_);
                    if (s) {
                        if ("radio" === s.type)
                            if (s.checked && this._element.classList.contains(o))
                                e = !1;
                            else {
                                var a = n.querySelector(b);
                                a && i(a).removeClass(o)
                            }
                        else
                            ("checkbox" !== s.type || "LABEL" === this._element.tagName && s.checked === this._element.classList.contains(o)) && (e = !1);
                        e && (s.checked = !this._element.classList.contains(o), i(s).trigger("change")),
                        s.focus(),
                        t = !1
                    }
                }
                this._element.hasAttribute("disabled") || this._element.classList.contains("disabled") || (t && this._element.setAttribute("aria-pressed", !this._element.classList.contains(o)), e && i(this._element).toggleClass(o))
            }, a.dispose = function() {
                i.removeData(this._element, l),
                this._element = null
            }, n._jQueryInterface = function(t) {
                return this.each(function() {
                    var e = i(this).data(l);
                    e || (e = new n(this), i(this).data(l, e)),
                    "toggle" === t && e[t]()
                })
            }, e = n, s = [{
                key: "VERSION",
                get: function() {
                    return "4.4.1"
                }
            }], (t = null) && r(e.prototype, t), s && r(e, s), n
        }();
    return i(document).on(A.CLICK_DATA_API, u, function(e) {
        var t = e.target;
        if (i(t).hasClass(a) || (t = i(t).closest(g)[0]), !t || t.hasAttribute("disabled") || t.classList.contains("disabled"))
            e.preventDefault();
        else {
            var n = t.querySelector(_);
            if (n && (n.hasAttribute("disabled") || n.classList.contains("disabled")))
                return void e.preventDefault();
            m._jQueryInterface.call(i(t), "toggle")
        }
    }).on(A.FOCUS_BLUR_DATA_API, u, function(e) {
        var t = i(e.target).closest(g)[0];
        i(t).toggleClass(c, /^focus(in)?$/.test(e.type))
    }), i(window).on(A.LOAD_DATA_API, function() {
        for (var e = [].slice.call(document.querySelectorAll(h)), t = 0, n = e.length; t < n; t++) {
            var s = e[t],
                a = s.querySelector(_);
            a.checked || a.hasAttribute("checked") ? s.classList.add(o) : s.classList.remove(o)
        }
        for (var i = 0, r = (e = [].slice.call(document.querySelectorAll(d))).length; i < r; i++) {
            var l = e[i];
            "true" === l.getAttribute("aria-pressed") ? l.classList.add(o) : l.classList.remove(o)
        }
    }), i.fn[e] = m._jQueryInterface, i.fn[e].Constructor = m, i.fn[e].noConflict = function() {
        return i.fn[e] = s, m._jQueryInterface
    }, m
});


!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("jquery"), require("./util.js")) : "function" == typeof define && define.amd ? define(["jquery", "./util.js"], t) : (e = e || self).Collapse = t(e.jQuery, e.Util)
}(this, function(o, c) {
    "use strict";
    function i(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function t(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t);
            e && (r = r.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable
            })),
            n.push.apply(n, r)
        }
        return n
    }
    function l(i) {
        for (var e = 1; e < arguments.length; e++) {
            var l = null != arguments[e] ? arguments[e] : {};
            e % 2 ? t(Object(l), !0).forEach(function(e) {
                var t,
                    n,
                    r;
                t = i,
                r = l[n = e],
                n in t ? Object.defineProperty(t, n, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[n] = r
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(l)) : t(Object(l)).forEach(function(e) {
                Object.defineProperty(i, e, Object.getOwnPropertyDescriptor(l, e))
            })
        }
        return i
    }
    o = o && o.hasOwnProperty("default") ? o.default : o,
    c = c && c.hasOwnProperty("default") ? c.default : c;
    var a = "collapse",
        g = "bs.collapse",
        e = "." + g,
        n = o.fn[a],
        u = {
            toggle: !0,
            parent: ""
        },
        h = {
            toggle: "boolean",
            parent: "(string|element)"
        },
        f = {
            SHOW: "show" + e,
            SHOWN: "shown" + e,
            HIDE: "hide" + e,
            HIDDEN: "hidden" + e,
            CLICK_DATA_API: "click" + e + ".data-api"
        },
        d = "show",
        _ = "collapse",
        m = "collapsing",
        p = "collapsed",
        y = "width",
        v = "height",
        C = ".show, .collapsing",
        A = '[data-toggle="collapse"]',
        s = function() {
            function s(t, e) {
                this._isTransitioning = !1,
                this._element = t,
                this._config = this._getConfig(e),
                this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + t.id + '"],[data-toggle="collapse"][data-target="#' + t.id + '"]'));
                for (var n = [].slice.call(document.querySelectorAll(A)), r = 0, i = n.length; r < i; r++) {
                    var l = n[r],
                        a = c.getSelectorFromElement(l),
                        s = [].slice.call(document.querySelectorAll(a)).filter(function(e) {
                            return e === t
                        });
                    null !== a && 0 < s.length && (this._selector = a, this._triggerArray.push(l))
                }
                this._parent = this._config.parent ? this._getParent() : null,
                this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray),
                this._config.toggle && this.toggle()
            }
            var e,
                t,
                n,
                r = s.prototype;
            return r.toggle = function() {
                o(this._element).hasClass(d) ? this.hide() : this.show()
            }, r.show = function() {
                var e,
                    t,
                    n = this;
                if (!this._isTransitioning && !o(this._element).hasClass(d) && (this._parent && 0 === (e = [].slice.call(this._parent.querySelectorAll(C)).filter(function(e) {
                    return "string" == typeof n._config.parent ? e.getAttribute("data-parent") === n._config.parent : e.classList.contains(_)
                })).length && (e = null), !(e && (t = o(e).not(this._selector).data(g)) && t._isTransitioning))) {
                    var r = o.Event(f.SHOW);
                    if (o(this._element).trigger(r), !r.isDefaultPrevented()) {
                        e && (s._jQueryInterface.call(o(e).not(this._selector), "hide"), t || o(e).data(g, null));
                        var i = this._getDimension();
                        o(this._element).removeClass(_).addClass(m),
                        this._element.style[i] = 0,
                        this._triggerArray.length && o(this._triggerArray).removeClass(p).attr("aria-expanded", !0),
                        this.setTransitioning(!0);
                        var l = "scroll" + (i[0].toUpperCase() + i.slice(1)),
                            a = c.getTransitionDurationFromElement(this._element);
                        o(this._element).one(c.TRANSITION_END, function() {
                            o(n._element).removeClass(m).addClass(_).addClass(d),
                            n._element.style[i] = "",
                            n.setTransitioning(!1),
                            o(n._element).trigger(f.SHOWN)
                        }).emulateTransitionEnd(a),
                        this._element.style[i] = this._element[l] + "px"
                    }
                }
            }, r.hide = function() {
                var e = this;
                if (!this._isTransitioning && o(this._element).hasClass(d)) {
                    var t = o.Event(f.HIDE);
                    if (o(this._element).trigger(t), !t.isDefaultPrevented()) {
                        var n = this._getDimension();
                        this._element.style[n] = this._element.getBoundingClientRect()[n] + "px",
                        c.reflow(this._element),
                        o(this._element).addClass(m).removeClass(_).removeClass(d);
                        var r = this._triggerArray.length;
                        if (0 < r)
                            for (var i = 0; i < r; i++) {
                                var l = this._triggerArray[i],
                                    a = c.getSelectorFromElement(l);
                                if (null !== a)
                                    o([].slice.call(document.querySelectorAll(a))).hasClass(d) || o(l).addClass(p).attr("aria-expanded", !1)
                            }
                        this.setTransitioning(!0);
                        this._element.style[n] = "";
                        var s = c.getTransitionDurationFromElement(this._element);
                        o(this._element).one(c.TRANSITION_END, function() {
                            e.setTransitioning(!1),
                            o(e._element).removeClass(m).addClass(_).trigger(f.HIDDEN)
                        }).emulateTransitionEnd(s)
                    }
                }
            }, r.setTransitioning = function(e) {
                this._isTransitioning = e
            }, r.dispose = function() {
                o.removeData(this._element, g),
                this._config = null,
                this._parent = null,
                this._element = null,
                this._triggerArray = null,
                this._isTransitioning = null
            }, r._getConfig = function(e) {
                return (e = l({}, u, {}, e)).toggle = Boolean(e.toggle), c.typeCheckConfig(a, e, h), e
            }, r._getDimension = function() {
                return o(this._element).hasClass(y) ? y : v
            }, r._getParent = function() {
                var e,
                    n = this;
                c.isElement(this._config.parent) ? (e = this._config.parent, void 0 !== this._config.parent.jquery && (e = this._config.parent[0])) : e = document.querySelector(this._config.parent);
                var t = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]',
                    r = [].slice.call(e.querySelectorAll(t));
                return o(r).each(function(e, t) {
                    n._addAriaAndCollapsedClass(s._getTargetFromElement(t), [t])
                }), e
            }, r._addAriaAndCollapsedClass = function(e, t) {
                var n = o(e).hasClass(d);
                t.length && o(t).toggleClass(p, !n).attr("aria-expanded", n)
            }, s._getTargetFromElement = function(e) {
                var t = c.getSelectorFromElement(e);
                return t ? document.querySelector(t) : null
            }, s._jQueryInterface = function(r) {
                return this.each(function() {
                    var e = o(this),
                        t = e.data(g),
                        n = l({}, u, {}, e.data(), {}, "object" == typeof r && r ? r : {});
                    if (!t && n.toggle && /show|hide/.test(r) && (n.toggle = !1), t || (t = new s(this, n), e.data(g, t)), "string" == typeof r) {
                        if (void 0 === t[r])
                            throw new TypeError('No method named "' + r + '"');
                        t[r]()
                    }
                })
            }, e = s, n = [{
                key: "VERSION",
                get: function() {
                    return "4.4.1"
                }
            }, {
                key: "Default",
                get: function() {
                    return u
                }
            }], (t = null) && i(e.prototype, t), n && i(e, n), s
        }();
    return o(document).on(f.CLICK_DATA_API, A, function(e) {
        "A" === e.currentTarget.tagName && e.preventDefault();
        var n = o(this),
            t = c.getSelectorFromElement(this),
            r = [].slice.call(document.querySelectorAll(t));
        o(r).each(function() {
            var e = o(this),
                t = e.data(g) ? "toggle" : n.data();
            s._jQueryInterface.call(e, t)
        })
    }), o.fn[a] = s._jQueryInterface, o.fn[a].Constructor = s, o.fn[a].noConflict = function() {
        return o.fn[a] = n, s._jQueryInterface
    }, s
});


!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("jquery"), require("popper.js"), require("./util.js")) : "function" == typeof define && define.amd ? define(["jquery", "popper.js", "./util.js"], t) : (e = e || self).Dropdown = t(e.jQuery, e.Popper, e.Util)
}(this, function(u, o, s) {
    "use strict";
    function i(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    function t(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t);
            e && (r = r.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable
            })),
            n.push.apply(n, r)
        }
        return n
    }
    function a(i) {
        for (var e = 1; e < arguments.length; e++) {
            var o = null != arguments[e] ? arguments[e] : {};
            e % 2 ? t(Object(o), !0).forEach(function(e) {
                var t,
                    n,
                    r;
                t = i,
                r = o[n = e],
                n in t ? Object.defineProperty(t, n, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[n] = r
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function(e) {
                Object.defineProperty(i, e, Object.getOwnPropertyDescriptor(o, e))
            })
        }
        return i
    }
    u = u && u.hasOwnProperty("default") ? u.default : u,
    o = o && o.hasOwnProperty("default") ? o.default : o,
    s = s && s.hasOwnProperty("default") ? s.default : s;
    var l = "dropdown",
        c = "bs.dropdown",
        h = "." + c,
        e = ".data-api",
        n = u.fn[l],
        p = new RegExp("38|40|27"),
        d = {
            HIDE: "hide" + h,
            HIDDEN: "hidden" + h,
            SHOW: "show" + h,
            SHOWN: "shown" + h,
            CLICK: "click" + h,
            CLICK_DATA_API: "click" + h + e,
            KEYDOWN_DATA_API: "keydown" + h + e,
            KEYUP_DATA_API: "keyup" + h + e
        },
        g = "disabled",
        _ = "show",
        m = "dropup",
        y = "dropright",
        v = "dropleft",
        b = "dropdown-menu-right",
        w = "position-static",
        P = '[data-toggle="dropdown"]',
        r = ".dropdown form",
        C = ".dropdown-menu",
        E = ".navbar-nav",
        D = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",
        A = "top-start",
        O = "top-end",
        j = "bottom-start",
        I = "bottom-end",
        N = "right-start",
        k = "left-start",
        T = {
            offset: 0,
            flip: !0,
            boundary: "scrollParent",
            reference: "toggle",
            display: "dynamic",
            popperConfig: null
        },
        K = {
            offset: "(number|string|function)",
            flip: "boolean",
            boundary: "(string|element)",
            reference: "(string|element)",
            display: "string",
            popperConfig: "(null|object)"
        },
        f = function() {
            function f(e, t) {
                this._element = e,
                this._popper = null,
                this._config = this._getConfig(t),
                this._menu = this._getMenuElement(),
                this._inNavbar = this._detectNavbar(),
                this._addEventListeners()
            }
            var e,
                t,
                n,
                r = f.prototype;
            return r.toggle = function() {
                if (!this._element.disabled && !u(this._element).hasClass(g)) {
                    var e = u(this._menu).hasClass(_);
                    f._clearMenus(),
                    e || this.show(!0)
                }
            }, r.show = function(e) {
                if (void 0 === e && (e = !1), !(this._element.disabled || u(this._element).hasClass(g) || u(this._menu).hasClass(_))) {
                    var t = {
                            relatedTarget: this._element
                        },
                        n = u.Event(d.SHOW, t),
                        r = f._getParentFromElement(this._element);
                    if (u(r).trigger(n), !n.isDefaultPrevented()) {
                        if (!this._inNavbar && e) {
                            if (void 0 === o)
                                throw new TypeError("Bootstrap's dropdowns require Popper.js (https://popper.js.org/)");
                            var i = this._element;
                            "parent" === this._config.reference ? i = r : s.isElement(this._config.reference) && (i = this._config.reference, void 0 !== this._config.reference.jquery && (i = this._config.reference[0])),
                            "scrollParent" !== this._config.boundary && u(r).addClass(w),
                            this._popper = new o(i, this._menu, this._getPopperConfig())
                        }
                        "ontouchstart" in document.documentElement && 0 === u(r).closest(E).length && u(document.body).children().on("mouseover", null, u.noop),
                        this._element.focus(),
                        this._element.setAttribute("aria-expanded", !0),
                        u(this._menu).toggleClass(_),
                        u(r).toggleClass(_).trigger(u.Event(d.SHOWN, t))
                    }
                }
            }, r.hide = function() {
                if (!this._element.disabled && !u(this._element).hasClass(g) && u(this._menu).hasClass(_)) {
                    var e = {
                            relatedTarget: this._element
                        },
                        t = u.Event(d.HIDE, e),
                        n = f._getParentFromElement(this._element);
                    u(n).trigger(t),
                    t.isDefaultPrevented() || (this._popper && this._popper.destroy(), u(this._menu).toggleClass(_), u(n).toggleClass(_).trigger(u.Event(d.HIDDEN, e)))
                }
            }, r.dispose = function() {
                u.removeData(this._element, c),
                u(this._element).off(h),
                this._element = null,
                (this._menu = null) !== this._popper && (this._popper.destroy(), this._popper = null)
            }, r.update = function() {
                this._inNavbar = this._detectNavbar(),
                null !== this._popper && this._popper.scheduleUpdate()
            }, r._addEventListeners = function() {
                var t = this;
                u(this._element).on(d.CLICK, function(e) {
                    e.preventDefault(),
                    e.stopPropagation(),
                    t.toggle()
                })
            }, r._getConfig = function(e) {
                return e = a({}, this.constructor.Default, {}, u(this._element).data(), {}, e), s.typeCheckConfig(l, e, this.constructor.DefaultType), e
            }, r._getMenuElement = function() {
                if (!this._menu) {
                    var e = f._getParentFromElement(this._element);
                    e && (this._menu = e.querySelector(C))
                }
                return this._menu
            }, r._getPlacement = function() {
                var e = u(this._element.parentNode),
                    t = j;
                return e.hasClass(m) ? (t = A, u(this._menu).hasClass(b) && (t = O)) : e.hasClass(y) ? t = N : e.hasClass(v) ? t = k : u(this._menu).hasClass(b) && (t = I), t
            }, r._detectNavbar = function() {
                return 0 < u(this._element).closest(".navbar").length
            }, r._getOffset = function() {
                var t = this,
                    e = {};
                return "function" == typeof this._config.offset ? e.fn = function(e) {
                    return e.offsets = a({}, e.offsets, {}, t._config.offset(e.offsets, t._element) || {}), e
                } : e.offset = this._config.offset, e
            }, r._getPopperConfig = function() {
                var e = {
                    placement: this._getPlacement(),
                    modifiers: {
                        offset: this._getOffset(),
                        flip: {
                            enabled: this._config.flip
                        },
                        preventOverflow: {
                            boundariesElement: this._config.boundary
                        }
                    }
                };
                return "static" === this._config.display && (e.modifiers.applyStyle = {
                    enabled: !1
                }), a({}, e, {}, this._config.popperConfig)
            }, f._jQueryInterface = function(t) {
                return this.each(function() {
                    var e = u(this).data(c);
                    if (e || (e = new f(this, "object" == typeof t ? t : null), u(this).data(c, e)), "string" == typeof t) {
                        if (void 0 === e[t])
                            throw new TypeError('No method named "' + t + '"');
                        e[t]()
                    }
                })
            }, f._clearMenus = function(e) {
                if (!e || 3 !== e.which && ("keyup" !== e.type || 9 === e.which))
                    for (var t = [].slice.call(document.querySelectorAll(P)), n = 0, r = t.length; n < r; n++) {
                        var i = f._getParentFromElement(t[n]),
                            o = u(t[n]).data(c),
                            s = {
                                relatedTarget: t[n]
                            };
                        if (e && "click" === e.type && (s.clickEvent = e), o) {
                            var a = o._menu;
                            if (u(i).hasClass(_) && !(e && ("click" === e.type && /input|textarea/i.test(e.target.tagName) || "keyup" === e.type && 9 === e.which) && u.contains(i, e.target))) {
                                var l = u.Event(d.HIDE, s);
                                u(i).trigger(l),
                                l.isDefaultPrevented() || ("ontouchstart" in document.documentElement && u(document.body).children().off("mouseover", null, u.noop), t[n].setAttribute("aria-expanded", "false"), o._popper && o._popper.destroy(), u(a).removeClass(_), u(i).removeClass(_).trigger(u.Event(d.HIDDEN, s)))
                            }
                        }
                    }
            }, f._getParentFromElement = function(e) {
                var t,
                    n = s.getSelectorFromElement(e);
                return n && (t = document.querySelector(n)), t || e.parentNode
            }, f._dataApiKeydownHandler = function(e) {
                if ((/input|textarea/i.test(e.target.tagName) ? !(32 === e.which || 27 !== e.which && (40 !== e.which && 38 !== e.which || u(e.target).closest(C).length)) : p.test(e.which)) && (e.preventDefault(), e.stopPropagation(), !this.disabled && !u(this).hasClass(g))) {
                    var t = f._getParentFromElement(this),
                        n = u(t).hasClass(_);
                    if (n || 27 !== e.which)
                        if (n && (!n || 27 !== e.which && 32 !== e.which)) {
                            var r = [].slice.call(t.querySelectorAll(D)).filter(function(e) {
                                return u(e).is(":visible")
                            });
                            if (0 !== r.length) {
                                var i = r.indexOf(e.target);
                                38 === e.which && 0 < i && i--,
                                40 === e.which && i < r.length - 1 && i++,
                                i < 0 && (i = 0),
                                r[i].focus()
                            }
                        } else {
                            if (27 === e.which) {
                                var o = t.querySelector(P);
                                u(o).trigger("focus")
                            }
                            u(this).trigger("click")
                        }
                }
            }, e = f, n = [{
                key: "VERSION",
                get: function() {
                    return "4.4.1"
                }
            }, {
                key: "Default",
                get: function() {
                    return T
                }
            }, {
                key: "DefaultType",
                get: function() {
                    return K
                }
            }], (t = null) && i(e.prototype, t), n && i(e, n), f
        }();
    return u(document).on(d.KEYDOWN_DATA_API, P, f._dataApiKeydownHandler).on(d.KEYDOWN_DATA_API, C, f._dataApiKeydownHandler).on(d.CLICK_DATA_API + " " + d.KEYUP_DATA_API, f._clearMenus).on(d.CLICK_DATA_API, P, function(e) {
        e.preventDefault(),
        e.stopPropagation(),
        f._jQueryInterface.call(u(this), "toggle")
    }).on(d.CLICK_DATA_API, r, function(e) {
        e.stopPropagation()
    }), u.fn[l] = f._jQueryInterface, u.fn[l].Constructor = f, u.fn[l].noConflict = function() {
        return u.fn[l] = n, f._jQueryInterface
    }, f
});


!function(r) {
    if (void 0 === r)
        throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
    var t = r.fn.jquery.split(" ")[0].split(".");
    if (t[0] < 2 && t[1] < 9 || 1 === t[0] && 9 === t[1] && t[2] < 1 || 4 <= t[0])
        throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")
}($);
!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("jquery"), require("./util.js")) : "function" == typeof define && define.amd ? define(["jquery", "./util.js"], t) : (e = e || self).Tab = t(e.jQuery, e.Util)
}(this, function(d, u) {
    "use strict";
    function i(e, t) {
        for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1,
            r.configurable = !0,
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r)
        }
    }
    d = d && d.hasOwnProperty("default") ? d.default : d,
    u = u && u.hasOwnProperty("default") ? u.default : u;
    var e = "tab",
        o = "bs.tab",
        t = "." + o,
        n = d.fn[e],
        f = {
            HIDE: "hide" + t,
            HIDDEN: "hidden" + t,
            SHOW: "show" + t,
            SHOWN: "shown" + t,
            CLICK_DATA_API: "click" + t + ".data-api"
        },
        l = "dropdown-menu",
        c = "active",
        m = "disabled",
        s = "fade",
        h = "show",
        v = ".dropdown",
        p = ".nav, .list-group",
        g = ".active",
        _ = "> li > .active",
        r = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
        y = ".dropdown-toggle",
        N = "> .dropdown-menu .active",
        a = function() {
            function r(e) {
                this._element = e
            }
            var e,
                t,
                n,
                a = r.prototype;
            return a.show = function() {
                var n = this;
                if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && d(this._element).hasClass(c) || d(this._element).hasClass(m))) {
                    var e,
                        r,
                        t = d(this._element).closest(p)[0],
                        a = u.getSelectorFromElement(this._element);
                    if (t) {
                        var i = "UL" === t.nodeName || "OL" === t.nodeName ? _ : g;
                        r = (r = d.makeArray(d(t).find(i)))[r.length - 1]
                    }
                    var o = d.Event(f.HIDE, {
                            relatedTarget: this._element
                        }),
                        l = d.Event(f.SHOW, {
                            relatedTarget: r
                        });
                    if (r && d(r).trigger(o), d(this._element).trigger(l), !l.isDefaultPrevented() && !o.isDefaultPrevented()) {
                        a && (e = document.querySelector(a)),
                        this._activate(this._element, t);
                        var s = function() {
                            var e = d.Event(f.HIDDEN, {
                                    relatedTarget: n._element
                                }),
                                t = d.Event(f.SHOWN, {
                                    relatedTarget: r
                                });
                            d(r).trigger(e),
                            d(n._element).trigger(t)
                        };
                        e ? this._activate(e, e.parentNode, s) : s()
                    }
                }
            }, a.dispose = function() {
                d.removeData(this._element, o),
                this._element = null
            }, a._activate = function(e, t, n) {
                function r() {
                    return a._transitionComplete(e, i, n)
                }
                var a = this,
                    i = (!t || "UL" !== t.nodeName && "OL" !== t.nodeName ? d(t).children(g) : d(t).find(_))[0],
                    o = n && i && d(i).hasClass(s);
                if (i && o) {
                    var l = u.getTransitionDurationFromElement(i);
                    d(i).removeClass(h).one(u.TRANSITION_END, r).emulateTransitionEnd(l)
                } else
                    r()
            }, a._transitionComplete = function(e, t, n) {
                if (t) {
                    d(t).removeClass(c);
                    var r = d(t.parentNode).find(N)[0];
                    r && d(r).removeClass(c),
                    "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !1)
                }
                if (d(e).addClass(c), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0), u.reflow(e), e.classList.contains(s) && e.classList.add(h), e.parentNode && d(e.parentNode).hasClass(l)) {
                    var a = d(e).closest(v)[0];
                    if (a) {
                        var i = [].slice.call(a.querySelectorAll(y));
                        d(i).addClass(c)
                    }
                    e.setAttribute("aria-expanded", !0)
                }
                n && n()
            }, r._jQueryInterface = function(n) {
                return this.each(function() {
                    var e = d(this),
                        t = e.data(o);
                    if (t || (t = new r(this), e.data(o, t)), "string" == typeof n) {
                        if (void 0 === t[n])
                            throw new TypeError('No method named "' + n + '"');
                        t[n]()
                    }
                })
            }, e = r, n = [{
                key: "VERSION",
                get: function() {
                    return "4.4.1"
                }
            }], (t = null) && i(e.prototype, t), n && i(e, n), r
        }();
    return d(document).on(f.CLICK_DATA_API, r, function(e) {
        e.preventDefault(),
        a._jQueryInterface.call(d(this), "show")
    }), d.fn[e] = a._jQueryInterface, d.fn[e].Constructor = a, d.fn[e].noConflict = function() {
        return d.fn[e] = n, a._jQueryInterface
    }, a
});


function apGetCookie(o) {
    for (var e = o + "=", i = document.cookie.split(";"), t = 0; t < i.length; t++) {
        for (var n = i[t]; " " === n.charAt(0);)
            n = n.substring(1);
        if (-1 !== n.indexOf(e))
            return n.substring(e.length, n.length)
    }
    return ""
}


function apSetCookie(o, e, i) {
    var t = new Date;
    t.setTime(t.getTime() + 24 * i * 60 * 60 * 1e3);
    var n = "expires=" + t.toGMTString();
    document.cookie = o + "=" + e + "; " + n + "; path=/"
}


$(document).ready(function() {
    var o = "ap-";
    "true" !== apGetCookie(o + "cookieinfo") && $("#ap-cookieinfo").show(),
    $("#ap-cookieinfo__close").click(function() {
        "true" !== apGetCookie(o + "cookieinfo") && apSetCookie(o + "cookieinfo", !0, 180),
        $("#ap-cookieinfo").hide()
    })
});


!function(e) {
    "use strict";
    e(document).ready(function() {
        e(".tx-indexedsearch-browsebox").length && e(".tx-indexedsearch-browsebox li a").each(function() {
            e(this).text().length || e(this).parent().hide()
        }),
        e("#ap-navbar-search-toggle").on("click", function() {
            e("#ap-navbar-search").toggleClass("active")
        }),
        e(".ap-burger__button").click(function() {
            e(".ap-burger-overlay").addClass("active"),
            e("body").addClass("ap-no-scroll")
        }),
        e(".ap-burger--close__button").click(function() {
            e(".ap-burger-overlay").removeClass("active"),
            e("body").removeClass("ap-no-scroll")
        }),
        e(".ap-menu__item--search").click(function() {
            e(".ap-menu__item--search").removeClass("active"),
            e(".ap-menu__item--search").addClass("active")
        }),
        e(window).width() < 768 && (e(".ap_produkt__item-link").on("click", function() {
            e(".ap-product__dropdown").slideUp();
            var t = e(this).siblings(".ap-product__dropdown");
            t.is(":hidden") && t.slideDown("slow", function() {
                e("html, body").animate({
                    scrollTop: e(this).parent().offset().top - 55
                }, "slow")
            })
        }), e(".js-toggle-btn--tab").on("click", function() {
            e(this).siblings(".ap-tab__buttons").is(":visible") ? e(this).siblings(".ap-tab__buttons").slideUp() : e(this).siblings(".ap-tab__buttons").slideDown()
        }), e(".ap-tab__buttons button").on("click", function() {
            e(this).parent().slideUp();
            var t = e(this).text();
            e(this).parent().siblings(".js-toggle-btn--tab").text(t)
        }), e(".ap-tab__buttons label").on("click", function() {
            e(this).parent().parent(".ap-tab__buttons").slideUp();
            var t = e(this).text();
            e(this).parent().parent(".ap-tab__buttons").siblings(".js-toggle-btn--tab").text(t)
        })),
        e(".js-toggle-cropped").on("click", function(t) {
            if (t.preventDefault(), e(this).siblings(".ap-cropped").is(":visible")) {
                var i = e(this).parent(".ap-accordion__body").height(),
                    s = e(this).siblings(".ap-cropped").height();
                e(this).parent(".ap-accordion__body").css("min-height", i),
                e(this).siblings(".ap-nocrop").css("min-height", s),
                e(this).siblings(".ap-cropped").hide(),
                e(this).siblings(".ap-nocrop").slideDown(100),
                e(this).text("Weniger anzeigen")
            } else
                e(this).text("Mehr anzeigen"),
                e(this).siblings(".ap-nocrop").slideUp(100, function() {
                    e(this).siblings(".ap-cropped").show()
                })
        })
    })
}(jQuery);